export interface Identity {
  playerId: string;
  name: string;
  avatar?: string;
  /** Discord access token. Sent to the table so the server can verify who you are. */
  token?: string;
}

/**
 * Who is this player? For local testing we make one up per browser tab.
 * When the Discord Embedded App SDK is wired in, this is replaced with the real Discord user
 * (id, username, avatar) after authenticating.
 */
export function getIdentity(): Identity {
  const params = new URLSearchParams(location.search);
  let id = sessionStorage.getItem("wg_player_id");
  if (!id) {
    id = "p_" + Math.random().toString(36).slice(2, 10);
    sessionStorage.setItem("wg_player_id", id);
  }
  const name = params.get("name") || sessionStorage.getItem("wg_name") || `Guest ${id.slice(-3)}`;
  sessionStorage.setItem("wg_name", name);
  return { playerId: params.get("id") || id, name };
}
